import classNames from 'classnames';
import { tone as textTone } from '../css/typography.css';

import {
  xsmallCorrection,
  smallCorrection,
  mediumCorrection,
  largeCorrection,
} from '../components/Icons/icon.css';

import { IconProps } from '../components/Icons/types';
import { iconSize } from '../components/hooks/icon.css';

const verticalAlignmentCorrection = {
  xsmall: xsmallCorrection,
  small: smallCorrection,
  medium: mediumCorrection,
  large: largeCorrection,
};

export const useIcon = ({ size, tone }: IconProps): { className: string } => {
  return {
    className: classNames(
      verticalAlignmentCorrection[size || 'medium'],
      iconSize[size || 'medium'],
      tone ? textTone[tone] : ''
    ),
  };
};
